import { Koi } from '@ksyos/koi';
import type { FeatureFlag } from '@common/interfaces/featureFlag';
import { FeatureFlagModelDataTypes } from '@common/interfaces/featureFlag';
import type { ISchemaContainer } from './schemaContainer';

export const featureFlagIdValidation = Koi.string()
    .min(8)
    .max(255)
    .regex(/^[A-Z0-9]+(?:_[A-Z0-9]+)*$/)
    .required();

const featureFlagEnabledValidation = Koi.boolean();

const featureFlagDescriptionValidation = Koi.string().min(32).max(255);

const featureFlagTypeValidation = Koi.string().valid(
    FeatureFlagModelDataTypes.Array,
    FeatureFlagModelDataTypes.Boolean,
    FeatureFlagModelDataTypes.String
);

const featureFlagDataValidation = Koi.when('type', {
    is: FeatureFlagModelDataTypes.Array,
    otherwise: Koi.when('type', {
        is: FeatureFlagModelDataTypes.Boolean,
        otherwise: Koi.when('type', {
            is: FeatureFlagModelDataTypes.String,
            then: Koi.object({
                value: Koi.string().required(),
            }),
        }),
        then: Koi.object().length(0).required(),
    }),
    then: Koi.object({
        value: Koi.array().items(Koi.string()).min(1).required(),
    }),
});

const featureFlagAvailableInFrontendValidation = Koi.boolean();

export const featureFlagCreateValidation = Koi.object({
    availableInFrontend: featureFlagAvailableInFrontendValidation.required(),
    data: featureFlagDataValidation.required(),
    description: featureFlagDescriptionValidation.required(),
    enabled: featureFlagEnabledValidation.required(),
    id: featureFlagIdValidation,
    type: featureFlagTypeValidation.required(),
});

export const featureFlagUpdateValidation = Koi.object({
    availableInFrontend: featureFlagAvailableInFrontendValidation,
    data: featureFlagDataValidation,
    description: featureFlagDescriptionValidation,
    enabled: featureFlagEnabledValidation,
    type: featureFlagTypeValidation,
}).with('data', 'type');

export const featureFlagSchema: ISchemaContainer<FeatureFlag> = {
    schema: Koi.object({
        data: featureFlagDataValidation,
        description: featureFlagDescriptionValidation,
        enabled: featureFlagEnabledValidation,
        id: featureFlagIdValidation,
        type: featureFlagTypeValidation,
    }).options({ convert: false, presence: 'required' }),
};
